import React from "react";

export default function EnquiryDetailModal({
  show,
  onClose,
  enquiry,
  onDelete,
  onEdit
}) {
  if (!show || !enquiry) return null;

  const formattedDate = enquiry.createdAt
    ? new Date(enquiry.createdAt).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    : "-";

  const formattedTime = enquiry.createdAt
    ? new Date(enquiry.createdAt).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    : "";

  return (
    <>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.55)", zIndex: 1050 }}
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content border-0 shadow-lg rounded-3">
            {/* Header */}
            <div
              className="modal-header text-white"
              style={{
                background: "linear-gradient(135deg, #bf3272 0%, #852d91 100%)",
                borderTopLeftRadius: "calc(0.3rem - 1px)",
                borderTopRightRadius: "calc(0.3rem - 1px)",
              }}
            >
              <h5 className="modal-title font-weight-bold d-flex align-items-center">
                <i className="fa fa-envelope-open-text mr-2"></i> Enquiry Details
              </h5>
              <button
                type="button"
                className="close text-white"
                onClick={onClose}
                aria-label="Close"
                style={{ opacity: 0.9, fontSize: "1.4rem" }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            {/* Body */}
            <div className="modal-body p-4" style={{ backgroundColor: "#fbfbfb" }}>
              {/* Top Meta info */}
              <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                <span className="badge badge-pill badge-primary px-3 py-2" style={{ backgroundColor: "#bf3272", fontSize: "0.85rem" }}>
                  <i className="fa fa-tag mr-1"></i> {enquiry.enquiry_for || "General Enquiry"}
                </span>
                <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                  <i className="fa fa-calendar mr-1"></i> {formattedDate} {formattedTime && `at ${formattedTime}`}
                </span>
              </div>

              {/* Member Contact Card */}
              <div className="card shadow-sm border-0 mb-3" style={{ borderRadius: "8px" }}>
                <div className="card-body p-3">
                  <h6 className="card-subtitle text-muted mb-3 font-weight-bold" style={{ fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    Sender Information
                  </h6>
                  <div className="row g-3">
                    {/* Name */}
                    <div className="col-md-4 col-12 mb-2">
                      <div className="text-muted small">Full Name</div>
                      <div className="font-weight-bold text-dark" style={{ fontSize: "1rem" }}>
                        <i className="fa fa-user-circle mr-1 text-primary"></i> {enquiry.name || "N/A"}
                      </div>
                    </div>

                    {/* Phone */}
                    <div className="col-md-4 col-12 mb-2">
                      <div className="text-muted small">Mobile Number</div>
                      <div className="font-weight-bold text-dark d-flex align-items-center" style={{ fontSize: "1rem" }}>
                        <i className="fa fa-phone mr-1 text-success"></i>
                        {enquiry.mobile ? (
                          <a
                            href={`tel:${enquiry.mobile}`}
                            className="text-dark text-decoration-none"
                            title="Click to call"
                          >
                            {enquiry.mobile}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-md-4 col-12 mb-2">
                      <div className="text-muted small">Email Address</div>
                      <div className="font-weight-bold text-dark" style={{ wordBreak: "break-all" }}>
                        {enquiry.email ? (
                          <a href={`mailto:${enquiry.email}`} className="text-info text-decoration-none">
                            <i className="fa fa-envelope mr-1"></i> {enquiry.email}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Message Content */}
              <div className="card shadow-sm border-0" style={{ borderRadius: "8px" }}>
                <div className="card-body p-3">
                  <h6 className="card-subtitle text-muted mb-2 font-weight-bold" style={{ fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    Enquiry Message
                  </h6>
                  <div
                    className="p-3 rounded bg-light border"
                    style={{
                      whiteSpace: "pre-wrap",
                      lineHeight: "1.6",
                      fontSize: "0.95rem",
                      color: "#2c3e50",
                      minHeight: "100px",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    {enquiry.message || "No message provided."}
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer bg-white border-top d-flex justify-content-between">
              <div>
                {onDelete && (
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => {
                      onClose();
                      onDelete(enquiry._id);
                    }}
                  >
                    <i className="fa fa-trash mr-1"></i> Delete Enquiry
                  </button>
                )}
              </div>
              <div className="d-flex gap-2">
                {onEdit && (
                  <button
                    type="button"
                    className="btn btn-primary btn-sm text-white mr-2"
                    style={{ backgroundColor: "#bf3272", borderColor: "#bf3272" }}
                    onClick={() => {
                      onClose();
                      onEdit(enquiry);
                    }}
                  >
                    <i className="fa fa-pencil mr-1"></i> Edit
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}
